import React from 'react';
import { WorkingModeEnum } from 'src/features/devices/devices.types';
import { formatWorkingMode } from 'src/utils/utils';

export interface HeadsetWorkingModeProps {
  workingMode: WorkingModeEnum;
  className?: string;
  style?: React.CSSProperties;
}

const HeadsetWorkingMode: React.FC<HeadsetWorkingModeProps> = props => {
  const { workingMode } = props;
  return <span>{formatWorkingMode(workingMode)}</span>;
};

export default HeadsetWorkingMode;
